import _ from 'lodash';
import i18n from 'i18n';
import { EXTRACT_VALUES, ExtractFilterScale } from './constants';

export const checkExtractFilterScale = (
    scale: string | undefined | null,
): scale is ExtractFilterScale => {
    if (!scale) {
        return false;
    }
    return _.keys(EXTRACT_VALUES).includes(scale);
};
export const checkExtractFilter = (
    scale?: string | null,
    value?: string | null,
): { shouldResetScale: boolean; shouldResetValue: boolean } => {
    const values =
        value == null || value === '' ? [] : value.split('|').map(_.toInteger);
    // TODO StrictNullCheck : Try to remove "!"
    const isScaleNotInOptions = !checkExtractFilterScale(scale);
    const someValueNotInOptions =
        // @ts-expect-error [TS migration] Was not detected by flow
        scale && _.difference(values, EXTRACT_VALUES[scale]).length > 0;
    // @ts-expect-error _.toInteger seems to have incorrect output type, or this check is useless
    const hasNonIntegerValue = values.includes(null);

    const shouldResetValue =
        isScaleNotInOptions || hasNonIntegerValue || !!someValueNotInOptions;
    const shouldResetScale = isScaleNotInOptions;
    return { shouldResetScale, shouldResetValue };
};

export const valueToOptions = (
    value: number | string,
    scale?: string,
): { value: string; label: string } => {
    const label =
        scale == null
            ? i18n.t(`sentence:${value}`)
            : i18n.t(`sentence:extract.${scale}.${value}`);
    return { value: _.toString(value), label };
};
